import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Cookies from 'js-cookie';


@Options({
    template: false,
    ui: {}
})

export default class BlogVideoPreview extends Marionette.View<Backbone.Model>{
    config?: object;
    element?: any;
    video?: any;
    url?: string;
    isVisible: boolean = false;
    isFading: boolean = false;
    isLoaded: boolean = false;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};

        this.element = this.$el[0];
        this.video = this.element.querySelector('video');

        this.url = this.video.getAttribute('data-source');
    }

    play() {
        if(!this.isFading) {
            this.video.currentTime = 0;
            this.video.play();
        }
    }

    onRender() {
        this.element.addEventListener('mouseenter', event => {
            /* if it hasn't been moused over yet, load the video */
            if(!this.isLoaded) {
                this.isLoaded = true;

                let canplay = () => {
                    this.el.classList.add('loaded');
                    this.play();
                    this.video.removeEventListener('canplay', canplay);
                }

                this.video.addEventListener('canplay', canplay);

                let source = document.createElement('source');
                source.setAttribute('src', this.url);
                this.video.appendChild(source);

                // `object-fit: cover` polyfill -- IE and Edge are bad :(
                let container = this.video.parentNode.getBoundingClientRect();
                if(container.width > container.height) {
                    this.video.setAttribute('width', '100%');
                    this.video.setAttribute('height', 'auto');
                } else {
                    this.video.setAttribute('width', 'auto');
                    this.video.setAttribute('height', '100%');
                }

                // this feels gross... but the above code didn't seem to
                // fix IE and Edge. the video refuses to go outside its
                // parent's bounds :(((
                if(window.navigator.userAgent.indexOf("Edge") > -1 || (<any>window.document).documentMode) {
                    this.video.parentNode.style.width = '107%';
                    this.video.parentNode.style.height = '100%';
                }
            }

            this.play()

            this.isFading = false;
        })

        this.element.addEventListener('mouseleave', event => {
            this.isFading = true;
            setTimeout(() => {
                if(this.isFading) {
                    this.video.pause();
                    this.isFading = false;
                }
            }, 400)
        })
    }
}




// WEBPACK FOOTER //
// ./@modules/views/blog-video-preview.ts